<template>
    <div>
        <div class="row">
            <div class="col-12">
                <div class="card">
                    <div class="card-body">
                        <div class="row mb-3">
                            <div class="col-12">
                                <div class="row">
                                    <div class="col-md-9"></div>
                                    <div class="col-md-1 d-flex justify-content-end align-items-center">
                                        <b-dropdown
                                            variant="warning"
                                            no-caret
                                            menu-class="dropdown-menu-250"
                                        >
                                            <template #button-content>
                                                <i class="mdi mdi-filter"></i>
                                            </template>
                                            <div class="px-3 pb-2">
                                                <label class="small text-muted mb-1">
                                                    {{ $t('module.status') }}
                                                </label>
                                                <multiselect
                                                    v-model="isActive"
                                                    track-by="value"
                                                    label="text"
                                                    :placeholder="'Select'"
                                                    :select-label="'Select'"
                                                    :selected-label="'Selected'"
                                                    :deselect-label="'Select'"
                                                    :options="statusDdl"
                                                    :searchable="true"
                                                    :allow-empty="false"
                                                    @input="searchListing"
                                                />
                                            </div>
                                        </b-dropdown>
                                    </div>
                                    <div class="col-md-2">
                                        <b-button
                                            class="btn-info col-12"
                                            v-on:click="openForm"
                                        >
                                            {{ $t('label.createX', []) }}
                                        </b-button>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="table-responsive mb-0">
                            <table
                                v-if="status.list"
                                class="table table-centered table-nowrap"
                            >
                                <thead>
                                    <tr>
                                        <th class="text-nowrap">#</th>
                                        <th class="text-nowrap">{{ $t('label.name') }}</th>
                                        <th class="text-nowrap">{{ $t('label.initial') }}</th>
                                        <th class="text-nowrap">{{ $t('label.email') }}</th>
                                        <th class="text-nowrap">{{ $t('label.createX', [$t('module.user')]) }}</th>
                                        <th class="text-nowrap">{{ $t('label.status') }}</th>
                                        <th class="text-nowrap">{{ $t('label.action') }}</th>
                                    </tr>
                                </thead>
                                <draggable
                                    v-model="candidateStatusList"
                                    tag="tbody"
                                    ghost-class="drag-ghost"
                                    chosen-class="drag-chosen"
                                    drag-class="drag-active"
                                    :animation="300"
                                    easing="cubic-bezier(0.25, 1, 0.5, 1)"
                                    :disabled="!status.save"
                                    handle=".draggable-item-handle"
                                    @change="requestUpdateSequence"
                                >
                                    <tr
                                        v-for="(item, index) in candidateStatusList"
                                        :key="index"
                                    >
                                        <td class="text-nowrap">
                                            <i class="mdi mdi-menu-swap font-size-18 cursor-pointer mr-1 draggable-item-handle"></i>
                                            {{ index + 1 }}
                                        </td>
                                        <td class="text-nowrap">{{ item.name }}</td>
                                        <td class="text-nowrap">
                                            <i :class="[item.isInitial ? 'text-info mdi mdi-checkbox-marked-circle' : 'text-muted mdi mdi-close-circle']"></i>
                                        </td>
                                        <td>
                                            <i :class="[item.isEmail ? 'text-success mdi mdi-checkbox-marked-circle' : 'text-muted mdi mdi-close-circle']"></i>
                                        </td>
                                        <td>
                                            <i :class="[item.isCreateUser ? 'text-info mdi mdi-checkbox-marked-circle' : 'text-muted mdi mdi-close-circle']"></i>
                                        </td>
                                        <td class="text-nowrap">
                                            <b-badge
                                                :variant="item.isActive ? 'success' : 'secondary'"
                                            >
                                                {{ item.isActive ? $t('label.active') : $t('label.inactive') }}
                                            </b-badge>
                                        </td>
                                        <td class="text-nowrap">
                                            <a
                                                href="javascript:void(0);"
                                                class="text-info"
                                                v-b-tooltip.hover
                                                :title="$t('label.updateX', [])"
                                                @click.stop="openForm(item)"
                                            >
                                                <i class="mdi mdi-pencil font-size-18"></i>
                                            </a>
                                            <a
                                                href="javascript:void(0);"
                                                class="text-info ml-1"
                                                v-b-tooltip.hover
                                                :title="item.isActive==0?$t('label.restoreX', []):$t('label.deleteX', [])"
                                                v-on:click="deleteConfirmation(item)"
                                            >
                                                <i :class="[`mdi font-size-18 mdi-delete-${item.isActive==0?'restore':'outline'}`]"></i>
                                            </a>
                                        </td>
                                    </tr>
                                </draggable>
                            </table>
                            <div v-else class="d-flex justify-content-center align-items-center p-5 m-5">
                                <b-spinner class="m-5" variant="info" role="status"></b-spinner>
                            </div>
                            <b-alert
                                v-if="tableRows.length == 0 && status.list"
                                show
                                variant="warning"
                                class="mt-0 text-center"
                            >
                                <i class="mdi mdi-alert-circle-outline"></i> {{ $t('message.noResultsFound') }}
                            </b-alert>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <b-modal
            id="candidate-status-form"
            :title="$t(candidateStatus.uuid ? 'label.updateX' : 'label.createX', [$t('module.candidateStatus')])"
            @hidden="closeForm"
            hide-footer
            hide-header-close
            centered
            size="lg"
        >
            <b-container fluid>
                <CandidateStatusForm
                    :candidateStatusUUID="candidateStatus.uuid"
                    :searchCriteria="searchCriteria"
                    @done="closeForm"
                    ref="candidateStatusForm"
                />
            </b-container>
        </b-modal>
        <b-modal
            id="candidate-status-delete"
            :title="candidateStatus.isActive==0 ? $t('label.restoreX', []) : $t('label.deleteX', [])"
            @hidden="closeForm"
            hide-header-close
        >
            <p class="my-4">{{ candidateStatus.isActive==0 ? $t('message.restoreConfirmation') : $t('message.deleteConfirmation') }}</p>
            <template #modal-footer>
                <b-button variant="danger" class="col-2" @click="$bvModal.hide('candidate-status-delete')">
                    {{ $t('label.cancel') }}
                </b-button>
                <b-button
                    variant="info"
                    class="ml-2 col-2"
                    v-on:click="requestDelete"
                    :disabled="!status.save"
                >
                    {{ candidateStatus.isActive==0 ? $t('label.restoreX', []) : $t('label.deleteX', []) }}
                </b-button>
            </template>
        </b-modal>
    </div>
</template>
<script>
import Multiselect from "vue-multiselect";
import draggable from "vuedraggable";
import { SESSION } from "@/constants";
import { sessionHelper, ddlHelper } from "@/utils";
import { mapState } from "vuex";
import { candidateStatusMethods } from "@/state/api";
import { CANDIDATE_STATUS_MODULE } from "@/state/api/candidateStatus.state";
import CandidateStatusForm from "@/views/pages/admin/candidateStatus/candidateStatusForm";

export default {
    components: { Multiselect, draggable, CandidateStatusForm },
    created() {
        sessionHelper.clearSearch(SESSION.CANDIDATE_STATUS_SEARCH) // clear search whenever page reload
        this.initSearchCriteria();
    },
    data() {
        return {
            statusDdl: ddlHelper.getActivationStatus(true),
            isActive: ddlHelper.getActivationStatus(true)[1],
            candidateStatusList: [],
            candidateStatus: {
                uuid: "",
                isActive: false,
            },
        };
    },
    methods: {
        ...candidateStatusMethods,
        initSearchCriteria() {
            let isDefault = true;
            if(sessionHelper.hasSearchCriteria(SESSION.CANDIDATE_STATUS_SEARCH)) {
                isDefault = false;
                this.searchCriteria = sessionHelper.retrieveSearch(SESSION.CANDIDATE_STATUS_SEARCH);
            }
            if(isDefault) {
                this.searchCriteria = {
                    isActive: this.isActive.value,
                };
            }
            this.getCandidateStatusList(this.searchCriteria);
        },
        getCandidateStatusList(filter) {
            this.getAllCandidateStatus({filter});
            this.searchCriteria = filter;
            sessionHelper.storeSearch(SESSION.CANDIDATE_STATUS_SEARCH, filter);
        },
        searchListing() {
            this.searchCriteria.searchArray = [];
            this.searchCriteria.isActive = this.isActive.value;
            this.getCandidateStatusList(this.searchCriteria);
        },
        requestUpdateSequence() {
            let data = {
                uuids: this.candidateStatusList.map((item) => item.uuid),
            };
            this.updateCandidateStatusSequence({data, filter: this.searchCriteria});
        },
        deleteConfirmation(data) {
            this.candidateStatus = {
                uuid: data.uuid,
                isActive: data.isActive,
            };
            this.$bvModal.show('candidate-status-delete');
        },
        requestDelete() {
			let data = {
                uuid: this.candidateStatus.uuid,
				isActive: this.candidateStatus.isActive == 0 ? 1 : 0,
			};
            this.updateCandidateStatusStatus({data, filter: this.searchCriteria})
                .then((result) => this.$nextTick(() => {
                    if (result?.success) this.$bvModal.hide('candidate-status-delete');
                }));
        },
        openForm(data) {
            if (data?.uuid) {
                this.candidateStatus = {
                    uuid: data.uuid,
                    isActive: data.isActive,
                };
            }
            this.$nextTick(() => {
                this.$bvModal.show('candidate-status-form');
            });
        },
        closeForm() {
            this.candidateStatus = {
                uuid: "",
                isActive: false,
            };
            this.$bvModal.hide('candidate-status-form');
        },
    },
	computed: {
		...mapState(CANDIDATE_STATUS_MODULE, ['status']),
		tableRows() {
			return this.$store.state.api.candidateStatus.list.data || [];
		},
		totalPage() {
			return this.$store.state.api.candidateStatus.list.pagination.total || 0;
		},
	},
    watch: {
        tableRows: {
            immediate: true,
            handler(value) {
                this.candidateStatusList = [...value].sort((a, b) => (a.sequence || 0) - (b.sequence || 0));
            },
        },
    },
}
</script>
<style>
.drag-ghost {
    opacity: 0.3;
    background: #e9ecef !important;
}

.drag-chosen {
    background: #f8f9fa !important;
}

.drag-active {
    background: #ffffff !important;
    box-shadow: 0 4px 12px rgba(0,0,0,.15);
}
</style>
